import { IClaimDownload } from 'types/Claims';
import { ThunkApiType } from 'types/utils';
import { exportListToExcel } from 'utils/download';
import { buildClaimsFilterParams } from 'utils/utils';
import authFetch, { checkForUnauthorizedResponse } from '../../utils/axios';

export const getClaimsByProviderThunk = async (
	_: string,
	thunkAPI: ThunkApiType,
) => {
	let getClaimsURL = `/claim`;

	const { page } = thunkAPI.getState().claims;
	const claimsSearchValues = thunkAPI.getState().form;

	const { sortingFields, sortingDirections } = thunkAPI.getState().form;

	const { queryParams: searchParams } =
		buildClaimsFilterParams(claimsSearchValues);
	getClaimsURL =
		getClaimsURL +
		`?page=${page}&sortingFields=${sortingFields}&sortingDirections=${sortingDirections}${
			searchParams ? searchParams : ''
		}`;
	try {
		const response = await authFetch.get(getClaimsURL);
		return response.data;
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};

export const downloadClaimsThunk = async (
	{ uuid, type }: IClaimDownload,
	thunkAPI: ThunkApiType,
) => {
	let getDownloadClaimIdURL = '/claim/downloadClaimDetail';
	let getDownloadClaimsListURL = `/claim/downloadClaimList`;

	const { downloadAll, selectedItems } = thunkAPI.getState().tableSelectedItems;

	if (!!uuid) {
		getDownloadClaimIdURL = getDownloadClaimIdURL + `?claimUuid=${uuid}`;
		try {
			const response = await authFetch.get(getDownloadClaimIdURL, {
				responseType: 'blob',
			});
			exportListToExcel(response.data, 'Claim', type);
			return true;
		} catch (error: ThunkApiType) {
			return checkForUnauthorizedResponse(error, thunkAPI);
		}
	} else {
		const { sortingFields, sortingDirections } = thunkAPI.getState().form;
		const { body: filterBody } = buildClaimsFilterParams(
			thunkAPI.getState().form,
		);

		const sortField = sortingFields || 'serviceDate,externalClaimId';
		const sortDirection = sortingDirections || 'DESC,DESC';

		const values = {
			...filterBody,
			format: type,
			claimUuids: downloadAll ? [] : selectedItems,
			claimExcludeUuids: downloadAll ? selectedItems : [],
			sortingFields: sortField,
			sortingDirections: sortDirection,
		};
		try {
			const response = await authFetch.post(getDownloadClaimsListURL, values, {
				responseType: 'blob',
			});
			exportListToExcel(response.data, 'Claims', type);
			return true;
		} catch (error: ThunkApiType) {
			return checkForUnauthorizedResponse(error, thunkAPI);
		}
	}
};
